import Vue from 'vue';
import { BETSLIP_VALIDATION_ERRORS } from 'bto-models/betslip/const';

/**
 * @typedef {ReturnType<typeof getDefaultState>['modalContent']} ModalContent 
 * @typedef {BETSLIP_VALIDATION_ERRORS[keyof BETSLIP_VALIDATION_ERRORS]} TBetslipValidationErrorCodes
 */

function getDefaultState() {
  return {
    isOpen: false,
    modalContent: {
      /**
       * Modal title
       * @type {string} 
       */
      title: '',
      /**
       * Optional Modal title
       * @type {string | null} 
       */
      message: '',
      /**
       * Optional Modal classes
       * @type {string | null}
       */
      modalClass: '',
      /**
       * Optional modal component name
       * @type {string | null} 
       */
      contentComponent: '',
      /**
       * Optional modal component props
       * @type {any} 
       */
      contentCompomentProps: {},
      /**
       * Optional modal footer callback function
       * @type {Function | null} 
       */
      footerCb: null,
      /**
       * Optional modal component footer button label
       * @type {string | null} 
       */
      footerBtnLabel: '',
    },
  };
}

/**
 * Open modal with given modal content
 * @param {Partial<ModalContent>} modalContent 
 */
export function openModal(modalContent) {
  Object.assign(modalStore, {
    isOpen: true,
    modalContent,
  });
}

/**
 * Close modal
 */
export function closeModal() {
  Object.assign(modalStore, getDefaultState());
}

/**
 * Show global popup modal if error is present 
 * @param {TBetslipValidationErrorCodes} [error] - optional error code
 */
export function showBetslipValidation(error) {
  if (!error) {
    return;
  }
  switch (error) {
    case BETSLIP_VALIDATION_ERRORS.MAX_ITEMS:
      openModal({
        title: 'Mobile.Message',
        modalClass: 'bto-sb-modalpopup-md',
        message: 'Mobile.BetSlip.MaxItemsExceeded',
      });
      break;
    case BETSLIP_VALIDATION_ERRORS.SAME_MATCH:
      openModal({
        title: 'Mobile.Message',
        modalClass: 'bto-sb-modalpopup-md',
        message: 'Mobile.multiplesamematchmarketsnotalowed',
      });
      break;
    case BETSLIP_VALIDATION_ERRORS.BOOSTED_IN_FREEBET:
      openModal({
        title: 'Mobile.Message',
        modalClass: 'bto-sb-modalpopup-md',
        message: 'BS.BoostedFreebetRule',
      });
      break;
    case BETSLIP_VALIDATION_ERRORS.BOOSTED_SAME_MATCH:
      openModal({
        title: 'Mobile.Message',
        modalClass: 'bto-sb-modalpopup-md',
        message: 'BS.BoostedSameMatchRule',
      });
      break;
  }
}

export const modalStore = Vue.observable(getDefaultState());
